import {useCallback, useContext}  from "react";
import GlobalContext from "../contexts/GlobalContext";

const useEnvironment = () => {
    const {state} = useContext(GlobalContext);
    const {environment} = state;

    const get_s3_url = useCallback((image_name, image_prefix = "") => {
        return `https://${environment.s3_bucket}.s3.${environment.aws_region}.amazonaws.com/${image_prefix}${image_name}`

    }, [environment]);

    return [environment, get_s3_url]
};

export default useEnvironment
